// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"3297":"css/xdealer_intro","5074":"css/home","7662":"css/refact/main","8252":"css/app","8266":"css/style"}[chunkId] + ".css";
};